module.exports = __webpack_public_path__ + "static/img/Hsyc(1).c93b217d.png";